export enum SigningDocumentTypes {
    ProposalForm = 1,
    MeetingForm = 2,
    ClaimForm = 3,
    Other = 4
}